import api from "./api.js";

export default class ReviewApi {
  static async create(data) {
    return await api.post(`api/review`, data);
  }

  static async getList(data) {
    return await api.get(`api/review`, data);
  }

  static async getDetail(id, data) {
    return await api.get(`api/review/${id}`, data);
  }

  static async update(id, data) {
    return await api.patch(`api/review/${id}`, data);
  }

  static async delete(id, params) {
    return await api.del(`api/review/${id}`, params);
  }
}
